import type { IconName } from '../_shared/models/icon.model';
import { completeFlagSet } from './flags';
import { completeIconSet } from './icons';

// Must match the sets IconComponent registers.
const ICON_NAMES = new Set<string>([...completeIconSet, ...completeFlagSet].map((icon) => icon.name));

/** Use before rendering icon names that come from content. */
export function isIconName(name: string | null | undefined): name is IconName {
    return !!name && ICON_NAMES.has(name);
}
